import { Outlet } from 'react-router-dom'
import Logo from '../Logo'

export default function AuthLayout() {
  return (
    <div className="min-h-screen bg-background-light dark:bg-background-dark flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Logo / brand header */}
        <div className="text-center mb-8">
          <Logo className="text-primary text-4xl inline-block" />
          <h1 className="text-2xl font-bold text-text-light dark:text-text-dark mt-2">
            Quantizant Account
          </h1>
          <p className="text-sm text-subtle-light dark:text-subtle-dark mt-1">
            PQC Transition Platform
          </p>
        </div>

        {/* Card */}
        <div className="bg-surface-light dark:bg-surface-dark rounded-xl shadow-lg border border-border-light dark:border-border-dark p-8">
          <Outlet />
        </div>
      </div>
    </div>
  )
}
